import { Component } from 'react';
import { qffAuthReload } from 'lib/qffAuth';

class QFFWidget extends Component {
  componentDidMount() {
    qffAuthReload();
  }

  render() {
    return (
      <div
        data-qff-auth="login"
        data-prop-client-id="hooroo"
        data-prop-logout-button-title="LOG OUT"
        data-prop-template="default"
        data-testid={this.props['data-testid']}
        data-hj-suppress
      />
    );
  }
}

export default QFFWidget;
